// Import Alpine, Alpine Components and Alpine Plugins
import Alpine from "alpinejs"
import ui from "@alpinejs/ui"
import collapse from "@alpinejs/collapse"
import focus from "@alpinejs/focus"

// Import Component specific JS
import mobileMenu from "./components/mobileMenu.js"
import referencesCarousel from "./components/referencesCarousel.js"
import quotesCarousel from "./components/quotesCarousel.js"
import navScrollSpy from "./components/navScrollSpy.js"
import scrollRegions from "./components/scrollRegions.js"

(async () => {
  // Make alpine easier to use from the DevTools
  window.Alpine = Alpine

  // AlpineJS Components: Headless UI
  // https://alpinejs.dev/components
  Alpine.plugin(ui)

  // AlpineJS PLugin: Collapse for smooth animations
  Alpine.plugin(collapse)
  Alpine.plugin(focus)

  // Alpine Data
  // https://alpinejs.dev/globals/alpine-data
  Alpine.data("mobileMenu", mobileMenu)
  Alpine.data("references_carousel", referencesCarousel);
  Alpine.data("quotes_carousel", quotesCarousel);

  Alpine.start()

  // Highlight the header nav item for the section currently in view.
  navScrollSpy()

  // Give sideways-scrolling boxes a tab stop.
  scrollRegions()
})();
